import * as echarts from 'echarts'
import { useEffect, useRef } from 'react'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'

// The endpoint returns a raw ECharts option, so this cannot go through ~/components/echarts:
// its Chart skips setOption unless data.type or data.chartType is set. Both UIs read this one.
export default function DetectionTrendChart({ url, params }) {
  const { data } = useRetryablePostJSON({ path: url, params })
  const divRef = useRef()
  const chartRef = useRef()

  useEffect(() => {
    const chart = echarts.init(divRef.current)
    chartRef.current = chart
    const observer = new ResizeObserver(() => chart.resize())
    observer.observe(divRef.current)
    observer.observe(document.querySelector('body'))
    return () => {
      chart.dispose()
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    if (!data?.series || !chartRef.current) return
    chartRef.current.clear()
    chartRef.current.setOption(data)
  }, [data])

  return <div ref={divRef} style={{ height: '23em', width: '100%' }} data-testid='chart-wrapper' />
}
